<p *ngIf="this.text.length > 100">
  {{(showMore) ? text : text | slice:0:100}} <span *ngIf="!showMore">...</span>
  <a href="javascript:;" *ngIf="!showMore" (click)="showMore=true">[Show More]</a>
  <a href="javascript:;" *ngIf="showMore" (click)="showMore=false">[Show Less]</a>
</p>
<p *ngIf="this.text.length <= 100">
  {{text}}
</p>
